<template>
  <div class="add-box">
    <el-form ref="dictform" :model="dictform" label-width="120px" class="user-form">
      <el-form-item label="字典名称:">
        <el-input v-model="dictform.name" placeholder="字典名称" class="user-input" />
      </el-form-item>
      <el-form-item label="字典类型:">
        <el-input v-model="dictform.type" placeholder="字典类型" class="user-input" />
      </el-form-item>
      <el-form-item label="字典码:">
        <el-input v-model="dictform.code" placeholder="字典码" class="user-input" />
      </el-form-item>
      <el-form-item label="字典值:">
        <el-input v-model="dictform.value" placeholder="字典值" class="user-input" maxlength="11" />
      </el-form-item>
      <el-form-item label="排序:">
        <el-input-number v-model="dictform.orderNum" :min="0" :max="1000" class="user-input" />
      </el-form-item>
      <el-form-item label="备注:">
        <el-input
          v-model="dictform.remark"
          type="textarea"
          :rows="4"
          placeholder="备注"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="update">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
	    data() {
    return {
      dictform: {
        id: '',
        name: '',
        type: '',
        code: '',
        value: '',
        orderNum: '0',
        remark: ''
      }
    }
	    },

  created() {
    this.$emit('setCurrentMenu', '字典管理')
    this.getDictInfo()
  },
	    methods: {
    getDictInfo() {
      const vm = this
      const id = vm.$route.params.id
      vm.dictform.id = id
      vm.axios.get(this.homePath() + '/sys/dict/info/' + id)
        .then(response => {
          const data = response.data
          console.log(data)
          if (data.status == '000000') {
            vm.dictform.code = data.dict.code
            vm.dictform.name = data.dict.name
            vm.dictform.type = data.dict.type
            vm.dictform.value = data.dict.value
            vm.dictform.orderNum = data.dict.orderNum
            vm.dictform.remark = data.dict.remark
          }
        })
        .catch(error => console.log(error))
    },

    update() {
      let past = true
      if (this.dictform.name == '') {
        this.$alert('字典名称不能为空', '提示')
        past = false
      }
      if (this.dictform.type == '') {
        this.$alert('字典类型不能为空', '提示')
        past = false
      }
      if (this.dictform.code == '') {
        this.$alert('字典码不能为空', '提示')
        past = false
      }
      if (this.dictform.value == '') {
        this.$alert('字典值不能为空', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios.post(this.homePath() + '/sys/dict/update', {
          id: vm.dictform.id,
          code: vm.dictform.code,
          name: vm.dictform.name,
          orderNum: vm.dictform.orderNum,
          remark: vm.dictform.remark,
          type: vm.dictform.type,
          value: vm.dictform.value
        })
          .then(response => {
            if (response.data.status == '000000') {
              this.$alert('修改成功', '提示', {
                callback: action => {
                  this.$router.push('/index/dict')
                }
              })
            } else {
              console.log(response.data.message)
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/dict')
    }
	    }
	  }
</script>

<style></style>
